(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["etforge-hero"] && !Shopify.designMode) return;
  try {
    
  function initEtforgeHeroShowcase(root) {
    const slides = Array.from(root.querySelectorAll('[data-etforge-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-etforge-dot]'));
    const previous = root.querySelector('[data-etforge-prev]');
    const next = root.querySelector('[data-etforge-next]');

    if (!slides.length) return;

    let activeIndex = 0;
    let pointerStartX = null;

    function showSlide(index) {
      activeIndex = (index + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.hidden = !isActive;
        slide.classList.toggle('is-active', isActive);
      });

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });
    }

    previous?.addEventListener('click', () => showSlide(activeIndex - 1));
    next?.addEventListener('click', () => showSlide(activeIndex + 1));

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => showSlide(dotIndex));
    });

    root.addEventListener('pointerdown', (event) => {
      pointerStartX = event.clientX;
    });

    root.addEventListener('pointerup', (event) => {
      if (pointerStartX === null) return;
      const distance = event.clientX - pointerStartX;
      pointerStartX = null;

      if (Math.abs(distance) < 48) return;
      showSlide(activeIndex + (distance < 0 ? 1 : -1));
    });
  }

  document.querySelectorAll('[data-etforge-hero-showcase]').forEach(initEtforgeHeroShowcase);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
